<template>
  <CContainer class="d-flex content-center min-vh-100">
    <CRow class="align-self-start">
      <CCol>
        <CCardGroup>
          <CCard class="card p-4 background">
            <CCardBody class="pt-0">
              <ValidationObserver ref="form" v-slot="{ handleSubmit }">
                <form
                  class="form-custom"
                  @submit.prevent="handleSubmit(submitLogin)"
                >
                  <img
                    :height="70"
                    class="c-sidebar-brand-full c-sidebar-brand-mobile mb-3 mt-0"
                    size="custom-size"
                    src="../../assets/fabbi_logo.jpeg"
                  />
                  <ValidationProvider
                    v-slot="{ errors }"
                    :name="$t('label.email')"
                    mode="passive"
                    rules="required|email|min:10|max:100"
                    vid="email"
                  >
                    <div class="form-group" role="group">
                      <div class="input-group">
                        <div class="input-group-prepend">
                          <span class="input-group-text">
                            <svg
                              height="12"
                              viewBox="0 0 16 12"
                              width="16"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                id="Path_34"
                                d="M15.7,67.962a.188.188,0,0,1,.3.147V74.5A1.5,1.5,0,0,1,14.5,76H1.5A1.5,1.5,0,0,1,0,74.5V68.113a.187.187,0,0,1,.3-.147c.7.544,1.628,1.234,4.816,3.55C5.778,72,6.891,73.009,8,73c1.116.009,2.25-1.025,2.884-1.488C14.072,69.2,15,68.506,15.7,67.962ZM8,72c.725.013,1.769-.912,2.294-1.294,4.147-3.009,4.463-3.272,5.419-4.022A.748.748,0,0,0,16,66.094V65.5A1.5,1.5,0,0,0,14.5,64H1.5A1.5,1.5,0,0,0,0,65.5v.594a.752.752,0,0,0,.287.591c.956.747,1.272,1.012,5.419,4.022C6.231,71.088,7.275,72.013,8,72Z"
                                data-name="Path 34"
                                fill="#777"
                                transform="translate(0 -64)"
                              />
                            </svg>
                          </span>
                        </div>
                        <input
                          v-model.trim="formData.email"
                          :class="[
                            'form-control',
                            errors[0] ? 'is-invalid' : ''
                          ]"
                          autocomplete="Email"
                          placeholder="Email"
                          type="text"
                        />
                        <div v-if="errors[0]" class="invalid-feedback">
                          {{ errors[0] }}
                        </div>
                      </div>
                    </div>
                  </ValidationProvider>

                  <ValidationProvider
                    v-slot="{ errors }"
                    :name="$t('label.password')"
                    mode="passive"
                    rules="required|min:6|max:50"
                    vid="password"
                  >
                    <div class="form-group" role="group">
                      <div class="input-group">
                        <div class="input-group-prepend">
                          <span class="input-group-text">
                            <svg
                              height="16"
                              viewBox="0 0 14 16"
                              width="14"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                id="Path_33"
                                d="M12.5,7h-.75V4.75a4.75,4.75,0,0,0-9.5,0V7H1.5A1.5,1.5,0,0,0,0,8.5v6A1.5,1.5,0,0,0,1.5,16h11A1.5,1.5,0,0,0,14,14.5v-6A1.5,1.5,0,0,0,12.5,7ZM9.25,7H4.75V4.75a2.25,2.25,0,0,1,4.5,0Z"
                                data-name="Path 33"
                                fill="#777"
                              />
                            </svg>
                          </span>
                        </div>
                        <input
                          v-model="formData.password"
                          :class="[
                            'form-control',
                            errors[0] ? 'is-invalid' : ''
                          ]"
                          autocomplete="curent-password"
                          placeholder="Password"
                          type="password"
                        />
                        <div v-if="errors[0]" class="invalid-feedback">
                          {{ errors[0] }}
                        </div>
                      </div>
                    </div>
                  </ValidationProvider>
                  <div class="row">
                    <div class="text-left col-4">
                      <!-- <button
                        type="button"
                        class="btn px-0 text-nowrap btn-link"
                      >
                      <router-link
                        :to="{
                          name:
                          'portal.password.forgot'
                        }"
                        class="auth-forward"
                      >
                        {{
                          $t(
                            "login.label_button_forgot_password"
                          )
                        }}
                      </router-link>
                      </button>-->
                    </div>
                    <div class="text-right col-8">
                      <button
                        class="btn px-4 text-nowrap btn-primary auth-btn"
                        type="submit"
                      >
                        {{ $t("login.label_button_login") }}
                      </button>
                    </div>
                  </div>
                </form>
              </ValidationObserver>
            </CCardBody>
          </CCard>
        </CCardGroup>
      </CCol>
    </CRow>
  </CContainer>
</template>

<script>
import {ValidationObserver, ValidationProvider} from "vee-validate";
import {mapActions} from "vuex";
import firebase from "../../firebase";

export default {
  name: "Login",
  metaInfo() {
    return {
      title: this.$t("page_title.page_login"),
      titleTemplate: "%s | " + this.$t("page_title.head_title")
    };
  },
  components: {
    ValidationObserver,
    ValidationProvider
  },
  data: () => ({
    formData: {
      email: "",
      password: ""
    }
  }),
  methods: {
    ...mapActions("auth", ["login"]),

    async submitLogin() {
      this.$root.$loading.start();
      await this.login(this.formData)
        .then(() => {
          this.$root.$loading.finish();
          this.$toast(
            this.$t("popup.label_login_success"),
            this.$t("login.label_button_login"),
            2000,
            "b-toaster-top-center",
            "success"
          );
          this.updateNotificationToken();
          this.$router.push({name: "TimeSheet"});
        })
        .catch(() => {
          this.$root.$loading.finish();
          this.$toast(
            this.$t("popup.label_login_fail"),
            this.$t("login.label_button_login"),
            2000,
            "b-toaster-top-center",
            "danger"
          );
        });
    },
    async updateNotificationToken() {
      let self = this;
      const messaging = firebase.messaging();
      messaging
        .requestPermission()
        .then(function () {
          return messaging.getToken();
        })
        .then(function (token) {
          self.$store.dispatch("auth/saveToken", {
            fcm_token: token
          });
        })
        .catch(function (err) {
          console.log(err);
        });
    }
  }
};
</script>
<style scoped>
.align-self-start {
  margin-top: 120px;
}

.invalid-feedback {
  text-align: left;
  margin-left: 40px;
}

@media only screen and (max-width: 739px) and (-webkit-min-device-pixel-ratio: 0) {
  .container {
    overflow-x: hidden;
  }

  .form-custom {
    width: 100%;
  }

  .card-group > .card {
    margin: 0 0.5rem;
  }

  .card-body.pt-0 {
    padding: 0px !important;
  }

  .c-sidebar-brand-mobile {
    height: 45%;
    width: 45%;
  }

  .card {
    padding: 1rem !important;
  }

  select,
  textarea,
  input {
    font-size: 1rem;
  }

  span.input-group-text {
    width: 2.625rem;
  }
}
</style>
